var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-text-wrapper"},[(_vm.pageTextDisplayHtml)?_c('div',{staticClass:"page-text",domProps:{"innerHTML":_vm._s(_vm.pageTextValue)}}):_c('div',{staticClass:"page-text"},[_vm._v(_vm._s(_vm.pageTextValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }